import { format } from "date-fns";
import { Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { getDisplayDeletionDate } from "@/components/JobDetails/DeletionUtils";

export const DeletionDate = ({
  uploadedAt,
  isAcquired,
}: {
  uploadedAt: Date;
  isAcquired: boolean;
}) => {
  const { t } = useTranslation("jobDetails");
  const displayDate = getDisplayDeletionDate(uploadedAt);
  const formattedDate = format(displayDate, "MMM d, yyyy");
  const shortFormattedDate = format(displayDate, "MMMM d");

  return (
    <div
      className="w-28 flex items-center justify-start"
      data-testid="acquisition-column"
    >
      {isAcquired ? (
        <span className="text-sm text-secondary-400 text-nowrap">
          {t("deletionDate.acquired")}
        </span>
      ) : (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <div className="flex items-center gap-1">
                <Trash2 className="w-3 h-3 text-secondary-300 shrink-0" />
                <span
                  className="hidden lg:inline text-sm text-secondary-300 text-nowrap"
                  data-testid="deletion-date-full"
                >
                  {formattedDate}
                </span>
                <span
                  className="hidden md:inline lg:hidden text-sm text-secondary-300 text-nowrap"
                  data-testid="deletion-date-medium"
                >
                  {formattedDate}
                </span>
                <span
                  className="inline md:hidden text-sm text-secondary-300 text-nowrap"
                  data-testid="deletion-date-short"
                >
                  {shortFormattedDate}
                </span>
              </div>
            </TooltipTrigger>
            <TooltipContent>
              <p>{t("deletionDate.tooltip", { displayDate: formattedDate })}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </div>
  );
};
